export const STATUS_ACTIVE = 'statusActive';
export const PREVIEW_BEFORE_START = 'previewBeforeStart';
export const PUBLIC_RULE = 'isPublic';
